import { Subject } from 'rxjs';

const subject = new Subject();

export const createTeamMemberTourGuideService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};